// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__2WFaK","details":"styles_details__10PW8"};